import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import waterfall from 'vue-waterfall2'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/reset.css'
import '@/assets/css/theme.css'
import '@/assets/css/elecustom.css'
import '@/assets/css/custom.less'
import '@/assets/css/home-en.less'
import '@/assets/fonts/iconfont.css'
import '@/config/utils/utils.js'
import i18n from '@/config/i18n/i18n'

Vue.use(waterfall);

Vue.prototype.sysVersion = "V1.0.0.4" // 系统版本号
Vue.prototype.prefix = '/deviceapplet';
Vue.prototype.imgHost = location.protocol+'//' + window.location.host +'/deviceapplet';

Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');